import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { useEffect, useState } from 'react';
import { track } from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { getRepName, getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { StyledModal } from '../../common/components/StyledModal';
import { submitPql } from '../../pql/submitPql';
import { trackTalkToSalesPql } from '../../utils/metricUtils';
import EmailModal from '../EmailModal';
import MeetingModal from '../MeetingModal';
import { MODAL_TYPES } from '../constants';
import { AssignableModalBody } from './AssignableModalBody';
import { GetACallSection } from './GetACallSection';
import { AssignableModalGD0532 } from '../AssignableModalGD0532';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AssignableModal = ({
  handleIframeSizeChange = () => {},
  hideBackground = false,
  onClose,
  _overrideModalHeaderText,
  _overrideCommunicationMethodKey,
  upgradeData,
  isFreePortal,
  modalRoot,
  repInfo,
  isGD0532ExperimentVariation = false
}) => {
  const [currentModalView, setCurrentModalView] = useState(_overrideCommunicationMethodKey || MODAL_TYPES.ASSIGNABLE);
  const [showGetACallTitle, setShowGetACallTitle] = useState(true);
  useEffect(() => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'viewed'
    }, getUpgradeDataTrackingProperties(upgradeData), {
      repName: getRepName(repInfo)
    }));
    void submitPql(Object.assign({}, upgradeData, {
      isRetail: false,
      isAssignable: true,
      repInfo
    }));
    trackTalkToSalesPql(upgradeData.app);
  }, [upgradeData, repInfo]);
  if (isGD0532ExperimentVariation) {
    return /*#__PURE__*/_jsx(AssignableModalGD0532, {
      handleIframeSizeChange: handleIframeSizeChange,
      hideBackground: hideBackground,
      onClose: onClose,
      _overrideModalHeaderText: _overrideModalHeaderText,
      _overrideCommunicationMethodKey: _overrideCommunicationMethodKey,
      upgradeData: upgradeData,
      modalRoot: modalRoot,
      repInfo: repInfo
    });
  }
  const commonProps = {
    hideBackground,
    onClose,
    upgradeData,
    repInfo
  };
  const handleBackClick = () => {
    handleIframeSizeChange(MODAL_TYPES.ASSIGNABLE);
    setCurrentModalView(MODAL_TYPES.ASSIGNABLE);
  };
  if (currentModalView === MODAL_TYPES.MEETING) {
    return /*#__PURE__*/_jsx(MeetingModal, Object.assign({}, commonProps, {
      onBackClick: handleBackClick
    }));
  }
  if (currentModalView === MODAL_TYPES.EMAIL) {
    return /*#__PURE__*/_jsx(EmailModal, Object.assign({}, commonProps, {
      onBackClick: handleBackClick
    }));
  }
  const optionalProps = modalRoot ? {
    rootNode: modalRoot
  } : {};
  return /*#__PURE__*/_jsxs(StyledModal, Object.assign({
    "data-test-id": "communication-methods-modal",
    hideBackground: hideBackground,
    width: currentModalView === MODAL_TYPES.ASSIGNABLE ? 850 : 650,
    use: "conversational"
  }, optionalProps, {
    children: [currentModalView === MODAL_TYPES.GET_A_CALL && (showGetACallTitle ? /*#__PURE__*/_jsxs(DialogHeader, {
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose({
          isClosedOnOptionsView: currentModalView === MODAL_TYPES.ASSIGNABLE
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.callTitle"
        })
      })]
    }) : /*#__PURE__*/_jsx(DialogHeader, {
      padding: "0",
      children: /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose({
          isClosedOnOptionsView: currentModalView === MODAL_TYPES.ASSIGNABLE
        })
      })
    })), currentModalView !== MODAL_TYPES.GET_A_CALL && /*#__PURE__*/_jsxs(DialogHeader, {
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose({
          isClosedOnOptionsView: currentModalView === MODAL_TYPES.ASSIGNABLE
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: _overrideModalHeaderText || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.communicationMethods.title"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: currentModalView === MODAL_TYPES.GET_A_CALL ? /*#__PURE__*/_jsx(GetACallSection, {
        onBackClick: handleBackClick,
        upgradeData: upgradeData,
        handleIframeSizeChange: handleIframeSizeChange,
        repInfo: repInfo,
        setShowGetACallTitle: setShowGetACallTitle
      }) : /*#__PURE__*/_jsx(AssignableModalBody, {
        setCurrentModalView: setCurrentModalView,
        upgradeData: upgradeData,
        handleIframeSizeChange: handleIframeSizeChange,
        showChatButton: isFreePortal,
        onClose: onClose,
        repInfo: repInfo
      })
    })]
  }));
};